import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import Localization from 'components/LayoutComponents/Localization'
import * as serviceWorker from './serviceWorker'

// app styles
import './global.scss'

if (process.env.REACT_APP_STAGE !== 'development') {
  console.log = () => {}
}

ReactDOM.render(
  <Localization>
    <App />
  </Localization>,
  document.getElementById('root'),
)

serviceWorker.register()
